import { render } from "./AdminTransactions.vue?vue&type=template&id=e24fa5ca"
import script from "./AdminTransactions.vue?vue&type=script&lang=js"
export * from "./AdminTransactions.vue?vue&type=script&lang=js"
script.render = render

export default script